import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_DIRECTORY_ITEM } from './../../../const/icons';

import { COMP_BUTTON_DIRECTORY_ITEM } from './../../../const/components';

import { FIELD_DIRECTORY_ITEM_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const DirectoryItem = (editor, options:any = {}) => {

  (FIELD_DIRECTORY_ITEM_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_DIRECTORY_ITEM,
    displayIcon: ICON_BUTTON_DIRECTORY_ITEM,
    model: {
      defaults: { ...Defaults,
        name: 'Directory Item',
        traits: [ ...Traits, FIELD_DIRECTORY_ITEM_SELECTOR]
      }
    }
  });
}